import { createContext, Dispatch, ReactNode, useContext, useReducer } from "react"
import reducer, { StoreState, initialState } from "./reducer"
import { StoreAction } from "../../../types/store"

interface StoreContext {
  statePlayLogs: StoreState
  dispatchPlayLogs: Dispatch<StoreAction>
}

export const Store = createContext<StoreContext>({
  statePlayLogs: initialState,
  dispatchPlayLogs: () => undefined,
})

export function useStorePlayLogs(): StoreContext {
  return useContext(Store)
}

interface Props {
  children: ReactNode | ReactNode[]
}

export function StoreProviderPlayLogs({ children }: Props) {
  const [statePlayLogs, dispatchPlayLogs] = useReducer(reducer, initialState)

  return <Store.Provider value={{ statePlayLogs, dispatchPlayLogs }}>{children}</Store.Provider>
}
